<template lang="pug">
  #action-summary
    .summary
      .title {{ establishment._name }} : Résumé de l'opération
      .subtitle Les fiches suivantes vont être retirées de l'établissement :
      sheet-aggregate-list(
        :sheetAggregates="sheetAggregates"
        :selectable="false"
      )
      .new-establishment(v-if="destinationSource === 'new-establishment'")
        .subtitle Et ajoutées à un nouvel établissement : "{{ newEstablishmentName }}"
      .existing-establishment(v-else)
        .subtitle Et ajoutées à l'établissement :
        establishment-selector-preview(:establishment="selectedEstablishment")
      .subtitle Cliquez sur "Terminer" pour procéder
    .actions
      button.cancel-btn(@click="$emit('close')") Annuler
      button.previous-btn(@click="goBack") Precédent
      button.confirm-btn(@click="$emit('confirm')") Terminer
</template>

<script>
import SheetAggregateList from '@/components/sheet-aggregate-list/SheetAggregateList.vue';
import EstablishmentSelectorPreview from '@/components/establishment-selector/EstablishmentSelectorPreview.vue';

export default {
  components: {
    SheetAggregateList,
    EstablishmentSelectorPreview,
  },
  props: {
    sheetAggregates: {
      type: Array,
      default: [],
    },
    establishment: {
      type: Object,
      required: true,
    },
    destinationSource: {
      type: String,
      required: true,
    },
    newEstablishmentName: {
      type: String,
      default: null
    },
    selectedEstablishment: {
      type: Object,
      default: null,
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: this.destinationSource === 'new-establishment' ? 'CreateEstablishment' : 'TargetEstablishmentChoice' });
    },
  },
}
</script>

<style lang="scss">
  #action-summary {
    .title {
      font-size: 32px;
      margin-bottom: .5em;
    }
    .subtitle {
      font-size: 20px;
      color: #8A8A8A;
      margin: 2em 0 1em 0;
    }
    .summary {
      flex-grow: 1;
      text-align: center;
      overflow-y: auto;
    }
    .existing-establishment {
      .selected-establishment {
        background: white;
        box-shadow: 0 3px 3px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
        border-radius: 8px;
        padding: 1em 1em 3em 1em;
        margin: 0;
        width: 240px;
      }
      > .title {
        margin-bottom: 0;
      }
      .thumbnail {
        img {
          height: 8em;
        }
      }
    }
  }
</style>